import { Message } from 'element-ui'
import { isObject } from 'lodash'

const redirectToLogin = (status, router) => {
  if (window.__POWERED_BY_QIANKUN__) {
    if (Wiz.globalSettings.globalConfig.redirectLoginPath) {
      window.location.href = Wiz.globalSettings.globalConfig.redirectLoginPath
      return
    }
    localStorage.clear()
    router.push(`/#/login?redirect=        ${window.location.href.split('#')[1]}`)
  }
}

const errorMsgWhiteList = Wiz.globalSettings.globalConfig?.errorMsgWhiteList || []
const MessageError = (message, router) => {
  if (!errorMsgWhiteList.includes(router.currentRoute.path)) {
    Message.error(message)
  }
}

let responseResult = false
const handleSuccessRes = (response, router) => {
  if (response.body && response.body.code === -1) {
    MessageError(response.body.msg, router)
    responseResult = true
  }
}

// 拦截请求响应
export default (store, router) => {
  Wiz.ApiHooks.ResponseIntercepter = (err, res, opts) => {
    responseResult = false
    // 超时取消等情况没有response
    if (!opts.response) {
      responseResult = true
      // 针对服务无法访问不在页面提示
      if (err.message.includes('the network is offline')) {
        console.error(`Error：${err.message}`)
      } else {
        MessageError(`Error：${err.message}`, router)
      }
      return responseResult
    }
    switch (opts.response.status) {
      case 200:
        handleSuccessRes(opts.response, router)
        break
      case 204:
        break
      case 401:
        redirectToLogin(opts.response.status, router)
        break
      case 404:
        MessageError(opts.response.error.message, router)
        break
      default:
        responseResult = true
        // 接口返回二进制流Error处理
        if (opts.response.body instanceof Blob) {
          opts.response.body.text().then((blobRes) => {
            try {
              const body = JSON.parse(blobRes)
              MessageError(body.error.message, router)
            } catch (error) {
              MessageError(`${opts.response.statusCode} ${opts.response.statusText}`, router)
            }
          })
          return responseResult
        }
        // 兼容后端java框架和abp框架错误返回类型
        const errorMsg = isObject(opts.response.body.error)
          ? opts.response.body.error.message
          : opts.response.body.message
        MessageError(errorMsg, router)
        break
    }
    return responseResult
  }
}
